import { fetcher } from '@commenda/utils';
import { UserEntityLinkRole } from '@prisma/client';

export async function updateAffiliateFirmMember(
  affiliateFirmId: string,
  userIdToBeChanged: string,
  body: {
    role?: UserEntityLinkRole;
    name?: string;
    email?: string;
  },
  userId?: string | null
) {
  const queryParams = userId ? `?userId=${userId}` : '';
  const response = await fetcher(
    `affiliate-firms/${affiliateFirmId}/update/${userIdToBeChanged}${queryParams}`,
    {
      method: 'POST',
      body,
    }
  );

  return response;
}
